<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M8.68,785.23c0,0-0.27,4.91-0.91,7.27c-0.6,2.23-1.33,4.52-2.72,6.36c-1.18,1.54-2.73,2.73-4.55,3.63
	c-1.82-0.91-3.37-2.09-4.55-3.63c-1.4-1.84-2.12-4.14-2.73-6.36c-0.64-2.36-0.91-7.27-0.91-7.27c3.64,0,8.18-2.73,8.18-2.73
	S5.05,785.23,8.68,785.23z M0.5,800.46c4.72-3.26,5.86-8.5,6.18-13.57c-1.78-0.44-3.39-0.76-6.18-2.42V800.46z"/>
</svg>

</template>